import { Box, IconButton, Typography } from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import CloseIcon from '@mui/icons-material/Close';
import { useRef, useState } from 'react';

type AddPhotoProps = {
  label: string;
  onChange: (file: File | null) => void;
  value?: File | null;
  onRemove?: () => void;
  errorText?: string;
  url?: string;
};

export const AddPhoto = ({ url, label, onChange, value, onRemove, errorText }: AddPhotoProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const openFilePicker = () => {
    inputRef.current?.click();
  };

  return (
    <Box
      sx={{
        width: '100%',
        border: '1px solid #E0E0E0',
        borderRadius: 2,
        p: 2,
        position: 'relative'
      }}>
      <Typography fontSize={14} fontWeight={600} mb={1}>
        {label}
      </Typography>

      {value && onRemove && (
        <IconButton size="small" onClick={onRemove} sx={{ position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>
      )}

      <Box
        sx={{
          borderRadius: 2,
          border: errorText
            ? '1px dashed red'
            : isDragging
              ? '2px dashed #1976d2'
              : '1px dashed #C5D0E6',
          height: 180,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          cursor: 'pointer',
          backgroundColor: isDragging ? 'rgba(25, 118, 210, 0.04)' : 'transparent'
        }}
        onClick={openFilePicker}
        onDragOver={(e) => {
          e.preventDefault();
          setIsDragging(true);
        }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setIsDragging(false);
          const file = e.dataTransfer.files?.[0] || null;
          if (file) {
            onChange(file);
          }
        }}>
        {/* Nếu đã có preview ảnh */}
        {url || value ? (
          <img
            src={value ? URL.createObjectURL(value) : url}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: 8
            }}
          />
        ) : (
          <>
            <Typography fontSize={14} mb={1}>
              Please take a picture.
            </Typography>
            <IconButton size="large" color="primary">
              <PhotoCameraIcon sx={{ fontSize: 40 }} />
            </IconButton>
          </>
        )}
      </Box>

      {errorText && (
        <Typography fontSize={12} color="error" mt={1}>
          {errorText}
        </Typography>
      )}

      {/* Input file hidden */}
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        hidden
        onChange={(e) => {
          const file = e.target.files?.[0] || null;
          if (file) {
            onChange(file);
          }
        }}
      />
    </Box>
  );
};
